/**
 * Leest optioneel JSON-bootstrap uit een script-tag of data-attribute.
 */
function parseBootstrapJson(raw) {
  if (!raw || !String(raw).trim()) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function readBootstrap(el, scriptId) {
  if (scriptId) {
    const script = document.getElementById(scriptId);
    const fromScript = parseBootstrapJson(script?.textContent);
    if (fromScript) {
      return fromScript;
    }
  }

  const mount =
    el ||
    (typeof document !== 'undefined' ? document.getElementById('vsb-vue-new-products') : null);
  if (mount) {
    const fromAttr = parseBootstrapJson(mount.getAttribute('data-bootstrap'));
    if (fromAttr) {
      return fromAttr;
    }
  }

  return {};
}
